import React, { useContext, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../helpers/AuthContext';

function Feild({ name, onchange, children }) {
  return (
    <div>
      <label htmlFor={name}> {children} </label>
      <input type="text" name={name} onChange={onchange} className="form-control" />
    </div>
  );
}

function CreactPost() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const initialValues = {
    title: '',
    postText: '',
  };

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/login');
    }
  }, []);

  const Enregister = (data) => {
    axios
      .post('/posts', data, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((response) => {
        navigate('/home');
        console.log('Enregistrement réussi');
      });
  };
  const validation = Yup.object().shape({
    title: Yup.string().required('Veuillez remplir le Titre'),
    postText: Yup.string().required('Veuillez remplir le Contenue'),
  });
  return (
    <div>
      <h1>Creation Post</h1>
      <Formik initialValues={initialValues} onSubmit={Enregister} validationSchema={validation}>
        <Form>
          <div className="d-flex">
            <div className="col">
              <label htmlFor="title">Titre : </label>
              <ErrorMessage className="text-danger" name="title" component="span" />
              <Field className="form-control" id="title" name="title" placeholder="Titre de publication" />
            </div>
            <div className="col">
              <label htmlFor="title">postText : </label>
              <ErrorMessage className="text-danger" name="postText" component="span" />
              <Field className="form-control" id="postText" name="postText" placeholder="Contenue" />
            </div>
            {/* <div className='col'>
                            <label htmlFor="title">User Name : </label>
                            <ErrorMessage className='text-danger' name='username' component='span' />
                            <Field className="form-control" id='username' name='username' placeholder='Utilisateur' />
                        </div> */}
          </div>
          <div className="row">
            <div className="col">
              <button className="mt-3 btn btn-primary" type="submit">
                Enregistrer
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default CreactPost;
